// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { rfqQuoteDetailsTotalStyles } from "@conklin/App/Widgets/RfqQuoteDetails/RfqQuoteDetailsTotal";

rfqQuoteDetailsTotalStyles.wrapper = {
    ...orderTotalDisplaySharedStyles.wrapper,
};

rfqQuoteDetailsTotalStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};

rfqQuoteDetailsTotalStyles.fullWidthGridItem = {
    width: 12,
};

rfqQuoteDetailsTotalStyles.subtotalLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

rfqQuoteDetailsTotalStyles.subtotalValueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

rfqQuoteDetailsTotalStyles.titleText = {
    ...orderTotalDisplaySharedStyles.titleText,
};

rfqQuoteDetailsTotalStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

rfqQuoteDetailsTotalStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

rfqQuoteDetailsTotalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
